import { render, staticRenderFns } from "./com-coupon.vue?vue&type=template&id=2fdbe2ba&scoped=true&"
import script from "./com-coupon.vue?vue&type=script&lang=js&"
export * from "./com-coupon.vue?vue&type=script&lang=js&"
import style0 from "./com-coupon.vue?vue&type=style&index=0&lang=css&"
import style1 from "./com-coupon.vue?vue&type=style&index=1&id=2fdbe2ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbe2ba",
  null
  
)

export default component.exports